"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var maxWidth = _constants.CONTAINER.MAX_WIDTH + _constants.GUTTER.CONTAINER.XL * _constants.SPACING * 2;
var gridInspect = function gridInspect(_ref) {
  var gutter = _ref.gutter;
  return process.env.NODE_ENV !== 'production' && {
    'body.grid-inspect &': {
      boxShadow: "\n      inset ".concat(gutter, " 0 #0000ff33,\n      inset -").concat(gutter, " 0 #0000ff33,\n      inset 0 0 0 1px #0000ff")
    }
  };
};
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "Containerstyle__Container",
  componentId: "sc-dvkkws-0"
})(function (_ref2) {
  var _ref2$theme = _ref2.theme,
    breakpoint = _ref2$theme.breakpoint,
    spacing = _ref2$theme.spacing;
  return _objectSpread(_objectSpread({
    boxSizing: 'border-box',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: "0 ".concat(spacing.inline['3xs']),
    height: '100%',
    width: '100%'
  }, gridInspect({
    gutter: "".concat(spacing.inline['3xs'])
  })), {}, _defineProperty(_defineProperty(_defineProperty({}, breakpoint.sm(), _objectSpread(_objectSpread({}, gridInspect({
    gutter: "".concat(spacing.inline['2xs'])
  })), {}, {
    padding: "0 ".concat(spacing.inline['2xs'])
  })), breakpoint.lg(), _objectSpread(_objectSpread({}, gridInspect({
    gutter: spacing.inline.xs
  })), {}, {
    padding: "0 ".concat(spacing.inline.xs)
  })), breakpoint.xl(), _objectSpread(_objectSpread({}, gridInspect({
    gutter: spacing.inline['2xl']
  })), {}, {
    padding: "0 ".concat(spacing.inline['2xl']),
    maxWidth: maxWidth
  })));
});